import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND}/api`;

export const api = axios.create({
    baseURL: API_URL,
});

// Token fallback (in case cookies fail in some envs)
export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("rm_token", token);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("rm_token");
    }
};

const stored = localStorage.getItem("rm_token");
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export const formatError = (err) => {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Errore sconosciuto";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
    return String(detail);
};

export const wsUrl = () => {
    const u = new URL(`${BACKEND}/api/ws`);
    u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
    return u.toString();
};

// ====== Date helpers (Europe/Rome, DST-aware) ======
// L'app opera su fuso italiano: i filtri "oggi" e i bucket di calendario
// devono usare il giorno italiano, non UTC (altrimenti i servizi notturni
// finirebbero conteggiati nel giorno UTC successivo durante l'ora legale).

export const romeDateString = (d = new Date()) => {
    try {
        // en-CA → YYYY-MM-DD (formato ISO-like); Europe/Rome gestisce DST automaticamente
        return new Intl.DateTimeFormat("en-CA", {
            timeZone: "Europe/Rome",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).format(d);
    } catch (e) {
        return d.toISOString().slice(0, 10);
    }
};

export const romeNow = () => {
    // Restituisce un Date *con valori interpretati come Europe/Rome*.
    // Utile per costruire bucket calendario coerenti con il fuso operativo.
    const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Europe/Rome",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit",
        hour12: false,
    }).formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t)?.value;
    return new Date(`${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}:${get("second")}`);
};
